// components/ChatModal.jsx
import React from "react";

export default function ChatModal({ title, onClose, children }) {
  return (
    <div className="chat-modal-overlay" role="dialog" aria-modal="true">
      <div className="chat-modal">
        <div className="chat-modal__header">
          <strong>{title}</strong>
          <button
            className="chat-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="chat-modal__body">{children}</div>
      </div>

      {/* minimal styles; move to CSS file if you prefer */}
      <style>{`
        .chat-modal-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,.5);
          display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .chat-modal {
          background: var(--lh-surface, #fff);
          color: var(--lh-text, #111);
          width: min(960px, 92vw);
          max-height: 88vh;
          display: flex; flex-direction: column;
          border-radius: 14px; box-shadow: 0 8px 40px rgba(0,0,0,.25);
        }
        .chat-modal__header {
          display: flex; justify-content: space-between; align-items: center;
          padding: 12px 16px; border-bottom: 1px solid var(--lh-border, #ddd);
          position: sticky; top: 0; background: inherit; z-index: 1;
        }
        .chat-modal__body { padding: 12px 16px; overflow: auto; }
        .chat-modal__close {
          border: 0; background: transparent; font-size: 20px; line-height: 1; cursor: pointer;
        }
      `}</style>
    </div>
  );
}
